import { CustomFrequency, DayWeek, FrequencyType, Poll, PollFrequency } from '../interfaces/Poll';

// enum FrecuencyDays{
//     once = 0
// }

// returns the frequency of the poll in the string format
export const getFrequencyPoll = (poll: (Partial<Poll>) | number | null): FrequencyType => {
    const freq = typeof poll === 'number' ? poll : poll?.frecuency;
    switch (freq) {
    case 0: return 'once';
    case 1: return 'daily';
    case 7: return 'weekly';
    case 30: return 'monthly';
    case -1: return 'demand';
    case null: return 'custom';
    default: return 'custom';
    }
};

export const allNullFrequencyValues = (freq: PollFrequency) => nullOrUndef(freq.frecuency) && nullOrUndef(freq.frequency_duration) &&
    nullOrUndef(freq.monthly_frequency_day) && nullOrUndef(freq.semanal_frequency);

export const getSpecificFrequency = (freq: PollFrequency, poll: Poll | null): FrequencyType => {
    if (allNullFrequencyValues(freq))
        return getFrequencyPoll(poll);
    else return getFrequencyPoll(freq.frecuency ?? null);
};

const nullOrUndef = <T,>(value: T | null | undefined) => value === null || value === undefined;

// returns the frequency in the days format. Reverse to getFrequencyPoll
export const getDaysFrequencyPoll = (freq: string) => {
    switch (freq) {
    case 'once': return 0;
    case 'daily': return 1;
    case 'weekly': return 7;
    case 'monthly': return 30;
    case 'demand': return -1;
    case 'custom': return -2;
    default: return -3;
    }
};

// returns all possible frequencies
export const getFrequencies = (): FrequencyType[] => ['once', 'daily', 'weekly', 'monthly', 'demand', 'custom'];

export const getFrequenciesCustom = (): CustomFrequency[] => ['daily', 'weekly',
    'monthly'];

export const getDaysWeek = (): DayWeek[] => [{ id: 0, label: 'monday' }, { id: 1, label: 'tuesday' }, { id: 2, label: 'wednesday' },
    { id: 3, label: 'thursday' }, { id: 4, label: 'friday' }, { id: 5, label: 'saturday' }, { id: -1, label: 'sunday' }];

export const getMomentJSDaysWeek = () => [{ id: 1, label: 'monday' }, { id: 2, label: 'tuesday' }, { id: 3, label: 'wednesday' },
    { id: 4, label: 'thursday' }, { id: 5, label: 'friday' }, { id: 6, label: 'saturday' }, { id: 0, label: 'sunday' }];

export const getMonthsYear = () => [{ id: 0, label: 'january' }, { id: 1, label: 'february' }, { id: 2, label: 'march' }, 
    { id: 3, label: 'april' }, { id: 4, label: 'may' }, { id: 5, label: 'june' }, { id: 6, label: 'july' }, { id: 7, label: 'august' }, 
    { id: 8, label: 'september' }, { id: 9, label: 'october' }, { id: 10, label: 'november' }, { id: 11, label: 'december' }];
